import { highlight, languages } from 'prismjs';
import React, { Dispatch, FC } from 'react';
import Editor from 'react-simple-code-editor';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism.css';
import { useTranslation } from '../../../translations';
import { RootFormState } from './FormElements';
interface EditStyleSheetProps {
  readonly state: RootFormState;
  readonly setState: Dispatch<RootFormState>;
}

export const EditStyleSheet: FC<EditStyleSheetProps> = ({ state, setState }) => {
  const { ts } = useTranslation();
  return (
    <div className="express-editor-custom-css">
      <div className="css-notice">
        <p>
          <strong>{ts('using_custom_css_will_override_default')}</strong>
        </p>
        <p>{ts('if_you_need_help_with_css_please_reach_out_to')}</p>
      </div>
      <Editor
        highlight={(c) => highlight(c, languages['css']!, 'CSS')}
        onValueChange={(c) => {
          setState({ ...state, layout: { ...state.layout, stylesheet: c } });
        }}
        padding={10}
        placeholder="/* Add your custom CSS below */"
        style={{
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: 12,
          // TOOD: Crashdoom - The bottom ConCat "COPYRIGHT" bar is on top of the textbox
          marginBottom: '55px',
          minHeight: '500px',
        }}
        value={state.layout.stylesheet}
      />
    </div>
  );
};
